import { useMemo } from 'react';
import { SystemRoleType } from 'Services/Api/Roles/Types';
import { useStores } from 'Hooks/useStore';

const ADMIN_ROLES: string[] = [
	SystemRoleType.SuperAdmin,
	SystemRoleType.Admin,
	SystemRoleType.Manager,
	SystemRoleType.Owner
];

const useLMSDashboard = () => {
	const { authStore } = useStores();

	const isAdminView = useMemo(() => {
		const role = authStore.currentUser?.primarySystemRole.role;
		return role ? ADMIN_ROLES.includes(role) : false;
	}, [authStore.currentUser]);

	return { isAdminView };
};

export default useLMSDashboard;
